import { mapState } from "vuex";

export const computed = {
  ...mapState("auth", ["empresaAtual"]),
  ...mapState("gerencial", ["controlador"])
}
